import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
SwiperCore.use([Navigation]);
var Container = styled.div.withConfig({
  displayName: "FeedImageSlider__Container",
  componentId: "sc-1p4nm5s-0"
})([".mySwiper{margin-top:1vw;--swiper-theme-color:#ede6db !important;max-width:65vw;.swiper-wrapper{.swiper-slide > img{width:100%;}}}"]);

var FeedImageSlider = function FeedImageSlider(_ref) {
  var images = _ref.images,
      onImageClick = _ref.onImageClick;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Swiper, {
      navigation: true,
      spaceBetween: 30,
      className: "mySwiper",
      children: images.map(function (image, index) {
        return /*#__PURE__*/_jsx(SwiperSlide, {
          children: /*#__PURE__*/_jsx("img", {
            src: image.image,
            onClick: onImageClick,
            style: {
              cursor: onImageClick ? 'pointer' : 'default'
            },
            alt: ""
          })
        }, index);
      })
    })
  });
};

export default FeedImageSlider;